import { useEditorStore } from "./editor.js";
import { levelsOf, useVillageStore } from "./village.js";
import { useTutorialStore } from "./tutorial.js";

/**
 * Keep the editor's Wall and Guild equal to the village's buildings (D-112).
 *
 * The server takes the levels from the buildings whatever the editor sends, so
 * an editor on the wrong levels would draw budgets the server then refuses.
 * The tutorial borrows the editor with its own practice levels, so nothing is
 * synced while it runs.
 */
export function syncEditorLevels(): void {
  if (useTutorialStore.getState().active) return;
  const economy = useVillageStore.getState().economy;
  if (!economy) return;
  const levels = levelsOf(economy);
  const wallLevel = levels.wall ?? 0;
  const engineersGuildLevel = levels.engineers_guild ?? 0;
  const { layout, setLevels } = useEditorStore.getState();
  if (layout.wallLevel === wallLevel && layout.engineersGuildLevel === engineersGuildLevel) return;
  setLevels({ wallLevel, engineersGuildLevel });
}

/** Follow the village from now on. Returns the unsubscribe. */
export function followVillageLevels(): () => void {
  syncEditorLevels();
  const offVillage = useVillageStore.subscribe((s, prev) => {
    if (s.economy !== prev.economy) syncEditorLevels();
  });
  const offTutorial = useTutorialStore.subscribe((s, prev) => {
    if (prev.active && !s.active) syncEditorLevels();
  });
  return () => {
    offVillage();
    offTutorial();
  };
}
